import { render } from "./DhInput.vue?vue&type=template&id=cb120b24"
import script from "./DhInput.vue?vue&type=script&lang=ts"
export * from "./DhInput.vue?vue&type=script&lang=ts"
script.render = render

export default script